import React, { useEffect, useRef } from 'react'

const ScrollToTop = ({ dependencies = [] }) => {
  const elementRef = useRef()
  useEffect(() => {
    if (elementRef?.current?.scrollIntoView) {
      elementRef.current.scrollIntoView({ behavior: 'auto', block: 'start' })
    }
  }, dependencies) // Scroll when dependencies change

  return <div ref={elementRef} className="scroll-target" />
}

export default ScrollToTop
